import { createSlice } from '@reduxjs/toolkit';

const initialState: ConfigState = {
  logo: {
    position: '',
    size: '',
  },
  mandant: '',
  isColorBlindMode: false,
  agentId: '',
  theme: {},
  customQuestions: [],
  customFields: [],
  customValues: {},
  answeredCustomQuestions: false,
  askForGewerkschaft: false,
  gewerkschaftsnummer: '',
  agentData: {
    agentNumber1: '',
    agentNumber2: '',
    street: '',
    houseNumber: '',
    firstName: '',
    lastName: '',
    company: '',
    city: '',
    zipcode: '',
    mobile: '',
    phone: '',
    email: '',
  },
  disableDataProtectionBox: false,
};

const ConfigSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    updateAnsweredCustomQuestions: (state, { payload }) => {
      state.answeredCustomQuestions = payload;
    },
    setConfig: (_, { payload }) => {
      return payload;
    },
    setGewerkschaftsnummer: (state, { payload }: { payload: string }) => {
      state.gewerkschaftsnummer = payload;
    },
  },
});

export const {
  setConfig,
  updateAnsweredCustomQuestions,
  setGewerkschaftsnummer,
} = ConfigSlice.actions;

export const configReducer = ConfigSlice.reducer;
